import { symbolUrl } from "@/lib/symbols";
import { Cherry, Citrus, Grape, Bell, Star, Gem, Coins, Diamond, Crown, Fish, Shell, Anchor, Ship, Circle, Trophy, Moon, Sun, Orbit, Satellite, Sparkles, Rocket, Egg, Shield, Swords, Castle, Zap, Flame } from "lucide-react";

export const SYMBOLS = {
  cherry: { Icon: Cherry, color: "#ff3b5c" },
  lemon: { Icon: Citrus, color: "#ffe14d" },
  grape: { Icon: Grape, color: "#b86bff" },
  bell: { Icon: Bell, color: "#fbbf24" },
  star: { Icon: Star, color: "#38bdf8" },
  seven: { color: "#ff2a2a" },
  emerald: { Icon: Gem, color: "#10b981" },
  sapphire: { Icon: Gem, color: "#3b82f6" },
  ruby: { Icon: Gem, color: "#ef4444" },
  coins: { Icon: Coins, color: "#fbbf24" },
  diamond: { Icon: Diamond, color: "#d8f3ff" },
  crown: { Icon: Crown, color: "#FFD700" },
  fish: { Icon: Fish, color: "#22d3ee" },
  shell: { Icon: Shell, color: "#f9a8d4" },
  anchor: { Icon: Anchor, color: "#60a5fa" },
  ship: { Icon: Ship, color: "#fbbf24" },
  pearl: { Icon: Circle, color: "#f1f5f9" },
  trident: { Icon: Trophy, color: "#FFD700" },
  moon: { Icon: Moon, color: "#c4b5fd" },
  sun: { Icon: Sun, color: "#fb923c" },
  orbit: { Icon: Orbit, color: "#38bdf8" },
  satellite: { Icon: Satellite, color: "#a3e635" },
  comet: { Icon: Sparkles, color: "#f0abfc" },
  rocket: { Icon: Rocket, color: "#FFD700" },
  egg: { Icon: Egg, color: "#fde68a" },
  shield: { Icon: Shield, color: "#60a5fa" },
  swords: { Icon: Swords, color: "#e5e7eb" },
  castle: { Icon: Castle, color: "#a78bfa" },
  fire: { Icon: Zap, color: "#fb923c" },
  dragon: { Icon: Flame, color: "#ef4444" },
};

export const SlotSymbol = ({ name, size = 44 }) => {
  const url = symbolUrl(name);
  if (url) return <img src={url} alt={name} draggable={false} className="w-[86%] h-[86%] object-contain select-none" style={{ filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.8))" }} />;
  const s = SYMBOLS[name];
  return (
    <div className="flex items-center justify-center w-full h-full" style={{ filter: `drop-shadow(0 0 8px ${s.color}99)` }}>
      {s.Icon ? (
        <s.Icon size={size} color={s.color} strokeWidth={1.7} fill={`${s.color}40`} />
      ) : (
        <span className="font-display font-black leading-none" style={{ fontSize: size, color: s.color, textShadow: "0 3px 0 #7B001C, 0 0 14px #ff2a2a" }}>7</span>
      )}
    </div>
  );
};
